<template>
  <div>
    <v-card id="admin-cancellations" class="px-5 py-2 mt-4 mb-5 elevation-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        sort-by="createdAt"
        :sort-desc="true"
        class="admin-cancellations-table elevation-0 mt-2"
        mobile-breakpoint="0"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': defaultPaginationItemsPerPageOptions,
        }"
        :items-per-page="20"
        dense
        @update:options="loadItems"
      ></v-data-table>
    </v-card>
  </div>
</template>

<script>
import { adminGetCancellations } from '@/lib/api.js'
import tableMixin from '@/views/components/core/tableMixin.js'

export default {
  mixins: [tableMixin],
  data: () => ({}),
  computed: {
    defaultHeaders() {
      return [
        {
          text: 'email',
          value: 'email',
        },
        {
          text: 'createdAt',
          value: 'createdAt',
        },
        {
          text: 'reason',
          value: 'reason',
        },
        {
          text: 'otherText',
          value: 'otherText',
        },
      ]
    },
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const filter = {}
        const { page, limit, sort } = this.getTablePaginationOptions(this.options)
        const response = await adminGetCancellations({ filter, page, limit, sort })
        this.setTablePaginatedResponse(response)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss"></style>
